import { defineMessages } from 'react-intl';

const messages = defineMessages({
  partI: {
    id: 'App.RentForecast.RDBudgetFormPartOne',
    defaultMessage: 'Part I',
  },
  partII: {
    id: 'App.RentForecast.RDBudgetFormPartTwo',
    defaultMessage: 'Part II',
  },
  partIII: {
    id: 'App.RentForecast.RDBudgetFormPartThree',
    defaultMessage: 'Part III',
  },
  partIV: {
    id: 'App.RentForecast.RDBudgetFormPartFour',
    defaultMessage: 'Part IV',
  },
  partV: {
    id: 'App.RentForecast.RDBudgetFormPartFive',
    defaultMessage: 'Part V',
  },
  complianceItemsPartI8VacancyRateLabel: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartI8VacancyRateLabel',
    defaultMessage: '8. Vacancy Rate: {vacancyRate}%',
  },
  complianceItemsPartI8VacancyRateTooltip: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartI8VacancyRateTooltip',
    defaultMessage: 'Vacancy Rate is greater than or equal to 10%',
  },
  complianceItemsPartI30NetCashLabel: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartI30NetCashLabel',
    defaultMessage: '30. Net Cash (Deficit): Proposed: {netCash}',
  },
  complianceItemsPartI30NetCashTooltip: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartI30NetCashTooltip',
    defaultMessage:
      'The amount is negative. Review the calculation and adjust as needed.',
  },
  complianceItemsPartISurplusCashLabel: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartISurplusCashLabel',
    defaultMessage: 'Surplus Cash: Proposed: {surplusCash}',
  },
  complianceItemsPartISurplusCashTooltipSurplusCashLabel: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartISurplusCashTooltipSurplusCashLabel',
    defaultMessage: 'Surplus Cash',
  },
  complianceItemsPartISurplusCashTooltipSurplusCashFormula: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartISurplusCashTooltipSurplusCashFormula',
    defaultMessage: ' = Cash Required - Cash Available',
  },
  complianceItemsPartISurplusCashTooltipCashAvailableLabel: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartISurplusCashTooltipCashAvailableLabel',
    defaultMessage: 'Cash Available',
  },
  complianceItemsPartISurplusCashTooltipCashAvailableFormula: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartISurplusCashTooltipCashAvailableFormula',
    defaultMessage: ' = Part I, Line 33 (Proposed)',
  },
  complianceItemsPartISurplusCashTooltipCashRequiredLabel: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartISurplusCashTooltipCashRequiredLabel',
    defaultMessage: 'Cash Required',
  },
  complianceItemsPartISurplusCashTooltipCashRequiredFormula: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartISurplusCashTooltipCashRequiredFormula',
    defaultMessage:
      ' = [(Part II, Line 41 (Proposed) - Part II, Line 40 (Proposed)) x 20%] + Part II, Line 40 (Proposed)',
  },
  complianceItemsPartI23ReturnToOwnerLabel: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartI23ReturnToOwnerLabel',
    defaultMessage:
      '23. Return to Owner / NP Asset Mgmt Fee: Proposed: {returnToOwner}',
  },
  complianceItemsPartI23ReturnToOwnerTooltipWarning1: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartI23ReturnToOwnerTooltipWarning1',
    defaultMessage:
      'RTO Proposed Budget cannot be greater than $0 since the vacancy rate is greater than or equal to 10%.',
  },
  complianceItemsPartI23ReturnToOwnerTooltipWarning2: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartI23ReturnToOwnerTooltipWarning2',
    defaultMessage:
      'RTO Proposed Budget should match RTO Current Budget since vacancy rate is less than 10%.',
  },
  complianceItemsPartI23ReturnToOwnerTooltipSuccess: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartI23ReturnToOwnerTooltipSuccess',
    defaultMessage:
      'Return to Owner fee is valid for the current vacancy rate.',
  },
  complianceItemsPartIIVariancesLabel: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartIIVariancesLabel',
    defaultMessage: 'All Variances Greater than 10% include comments',
  },
  complianceItemsPartIIVariancesTooltip: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartIIVariancesTooltip',
    defaultMessage:
      'A variance is greater than 10% (either higher or lower) and no comment has been added. Add a comment or adjust the variance accordingly.', // eslint-disable-line max-len
  },
  complianceItemsPartIISubTotalAdministrativeLabel: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartIISubTotalAdministrativeLabel',
    defaultMessage:
      '33. Sub-Total Administrative: {partIILine33ProposedValue} divided by Part 1 Sub-Total of Operational Cash Sources: {partILine10ProposedValue} = {percentage}%', // eslint-disable-line max-len
  },
  complianceItemsPartIISubTotalAdministrativeTooltip: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartIISubTotalAdministrativeTooltip',
    defaultMessage:
      'The Sub-Total Administrative exceeds 23% of Part I, Line 10 (Income) and no comment has been added. Add a comment or adjust the sub-total to correct this.', // eslint-disable-line max-len
  },
  complianceItemsPartIITaxCreditDebtServiceLabel: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartIITaxCreditDebtServiceLabel',
    defaultMessage:
      'Tax Credit Debt Service: Calculation: ({partILine10ProposedValue} - ({partILine16ProposedValue} + {partILine22ProposedValue} + {partILine23ProposedValue})) / ({partILine17ProposedValue} + {partILine25ProposedValue}) = {taxServiceDebtRatio}', // eslint-disable-line max-len
  },
  complianceItemsPartIITaxCreditDebtServiceTooltip: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartIITaxCreditDebtServiceTooltip',
    defaultMessage:
      'The Tax Credit Debt Service ratio is outside the 1.15 - 1.30 range for an RD/tax credit layered property.', // eslint-disable-line max-len
  },
  complianceItemsPartIIIEndingBalanceLabel: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartIIIEndingBalanceLabel',
    defaultMessage: '8. Ending Balance: {partIIILine8ProposedValue}',
  },
  complianceItemsPartIIIEndingBalanceValidationNegative: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartIIIEndingBalanceValidationNegative',
    defaultMessage:
      'The ending balance cannot be negative. Please review and adjust the amount accordingly.', // eslint-disable-line max-len
  },
  complianceItemsPartIIIEndingBalanceValidationReservedMaxAmount: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartIIIEndingBalanceValidationReservedMaxAmount',
    defaultMessage:
      'The ending balance exceeds the reserved max amount on Part III of {partIIIReservedMaxAmount}. Please adjust the amount to stay within the reserved limit.', // eslint-disable-line max-len
  },
  complianceItemsPartIIIEndingBalanceValidationInsuranceDeductibleAmount: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartIIIEndingBalanceValidationInsuranceDeductibleAmount',
    defaultMessage:
      'The ending balance cannot be less than the insurance deductible of {partIIIInsuranceDeductibleAmount}. Please update the balance to meet the required minimum.', // eslint-disable-line max-len
  },
  complianceItemsPartIIIEndingBalanceValidation538Loan: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartIIIEndingBalanceValidation538Loan',
    defaultMessage:
      'The property has a 538 loan, and the ending balance is less than $1,000 per unit. Please increase the ending balance to meet the minimum amount of {minimumEndingBalance}.', // eslint-disable-line max-len
  },
  complianceItemsPartIIIEndingBalanceWithCommentLabel: {
    id: 'App.RentForecast.RDBudgetFormComplianceItemsPartIIIEndingBalanceWithCommentLabel',
    defaultMessage: '8. Ending Balance: includes a comment',
  },
  complianceItemsPartIIIReserveAccountRuleLabel: {
    id: 'App.RentForecast.RDBudgetFormPartIIIReserveAccountRuleLabel',
    defaultMessage: 'Reserve Account Required Balance',
  },
  complianceItemsPartIIIReserveAccountRuleTooltipWarning: {
    id: 'App.RentForecast.RDBudgetFormPartIIIReserveAccountRuleTooltipWarning',
    defaultMessage:
      'Reserve Account Required Balance is less than the Ending Balance.',
  },
  complianceItemsPartIIIReserveAccountRuleTooltipSuccess: {
    id: 'App.RentForecast.RDBudgetFormPartIIIReserveAccountRuleTooltipSuccess',
    defaultMessage:
      'Reserve Account Required Balance equals or exceeds the Ending Balance.',
  },
  complianceItemsPartIBeginningBalanceLabel: {
    id: 'App.RentForecast.RDBudgetModal.ComplianceItemsPartIBeginningBalanceLabel',
    defaultMessage: '1. Beginning Balance includes Comment',
  },
  complianceItemsPartIIIBeginningBalanceLabel: {
    id: 'App.RentForecast.RDBudgetModal.ComplianceItemsPartIIIBeginningBalanceLabel',
    defaultMessage: '1. Beginning Balance includes Comment',
  },
  complianceItemsPartIBeginningBalanceTooltip: {
    id: 'App.RentForecast.RDBudgetModal.ComplianceItemsPartIBeginningBalanceTooltip',
    // eslint-disable-next-line max-len
    defaultMessage:
      'A comment is required for the Beginning Balance in Part III to explain ' +
      'any adjustments made to the auto-calculated value.',
  },
  complianceItemsOtherCommentsLabel: {
    id: 'App.RentForecast.RDBudgetModal.ComplianceItemsOtherCommentsLabel',
    defaultMessage:
      'All fields labeled “Other” with a non-zero amount include comments',
  },
  create35607Title: {
    id: 'App.RentForecast.BudgetTypeModal.Create35607Title',
    defaultMessage: 'Create 3560-7',
  },
  description: {
    id: 'App.RentForecast.BudgetTypeModal.Description',
    defaultMessage:
      'You are about to generate the {reportName} using the current budget data. ' +
      'Make sure all budget details are finalised before continuing.',
  },
  budgetTypeLabel: {
    id: 'App.RentForecast.BudgetTypeModal.BudgetTypeLabel',
    defaultMessage: 'Budget Type',
  },
  chooseBudgetType: {
    id: 'App.RentForecast.BudgetTypeModal.ChooseBudgetType',
    defaultMessage: 'Select Reason(s)',
  },
  budgetTypeInitial: {
    id: 'App.RentForecast.BudgetTypeModal.Type.Initial',
    defaultMessage: 'Initial',
  },
  budgetTypeRegular: {
    id: 'App.RentForecast.BudgetTypeModal.Type.RegularReport',
    defaultMessage: 'Regular Report',
  },
  budgetTypeRentChange: {
    id: 'App.RentForecast.BudgetTypeModal.Type.RentChange',
    defaultMessage: 'Rent Change',
  },
  budgetTypeSmr: {
    id: 'App.RentForecast.BudgetTypeModal.Type.Smr',
    defaultMessage: 'SMR',
  },
  budgetTypeOther: {
    id: 'App.RentForecast.BudgetTypeModal.Type.OtherServicing',
    defaultMessage: 'Other Servicing',
  },
  cancel: {
    id: 'App.Common.Cancel',
    defaultMessage: 'Cancel',
  },
  generate: {
    id: 'App.RentForecast.BudgetTypeModal.Generate',
    defaultMessage: 'Generate',
  },
  autoCalculatePart1ModalBody: {
    id: 'App.RentForecast.RDBudgetModal.AutoCalculate.Body',
    defaultMessage:
      'Confirming this action will update the Proposed Budget values on Part I using your company’s business rules.',
  },
  autoCalculatePart1ModalWarning: {
    id: 'App.RentForecast.RDBudgetModal.AutoCalculate.Warning',
    defaultMessage: `This will override any existing Proposed Values that are entered on Part I.
    If you only want to update a single field, cancel and update it manually instead.`,
  },
});

export default messages;
